module.exports = __webpack_public_path__ + "img/gp.be825203.svg";